module.exports = __webpack_public_path__ + "img/placeholder.63662f8d.png";